import { Close } from '@mui/icons-material'
import { Button, type ButtonProps } from '@mui/material'

export const CloseWindowButton = (props: ButtonProps) => {
  const handleClick = () => {
    window.close()
  }

  return (
    <Button
      color="secondary"
      {...props}
      startIcon={<Close />}
      onClick={handleClick}
    >
      {props.children ?? 'Cancel'}
    </Button>
  )
}
